import { render, staticRenderFns } from "./Upgrading-from-v4-to-v5.md?vue&type=template&id=9c7a0580&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports